import {BasicService} from './basic.service';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { API_OPERATOR_URL } from '../../connection.data';
import { BehaviorSubject } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable()
export class OperatorService extends BasicService {
    constructor(http: HttpClient){
        super(http);
        this.baseUrl = API_OPERATOR_URL;
    }
}